export const COUNTRY_OPTIONS = [
  { text: 'United States', value: 'United States', icon: require('../assets/icons/US.png') },
  { text: 'Argentina', value: 'Argentina', icon: require('../assets/icons/AR.png') },
  { text: 'Armenia', value: 'Armenia', icon: require('../assets/icons/AM.png') },
  { text: 'Australia', value: 'Australia', icon: require('../assets/icons/AU.png') },
  { text: 'Austria', value: 'Austria', icon: require('../assets/icons/AT.png') },
  { text: 'Belgium', value: 'Belgium', icon: require('../assets/icons/BE.png') },
  { text: 'Belize', value: 'Belize', icon: require('../assets/icons/BZ.png') },
  { text: 'Brazil', value: 'Brazil', icon: require('../assets/icons/BR.png') },
  { text: 'Bulgaria', value: 'Bulgaria', icon: require('../assets/icons/BG.png') },
  { text: 'Canada', value: 'Canada', icon: require('../assets/icons/CA.png') },
  { text: 'China', value: 'China', icon: require('../assets/icons/CN.png') },
  { text: 'Croatia', value: 'Croatia', icon: require('../assets/icons/HR.png') },
  { text: 'Czech Republic', value: 'Czech Republic', icon: require('../assets/icons/CZ.png') },
  { text: 'Denmark', value: 'Denmark', icon: require('../assets/icons/DK.png') },
  { text: 'Egypt', value: 'Egypt', icon: require('../assets/icons/EG.png') },
  { text: 'Finland', value: 'Finland', icon: require('../assets/icons/FI.png') },
  { text: 'France', value: 'France', icon: require('../assets/icons/FR.png') },
  { text: 'Germany', value: 'Germany', icon: require('../assets/icons/DE.png') },
  { text: 'Greece', value: 'Greece', icon: require('../assets/icons/GR.png') },
  { text: 'Hungary', value: 'Hungary', icon: require('../assets/icons/HU.png') },
  { text: 'Iceland', value: 'Iceland', icon: require('../assets/icons/IS.png') },
  { text: 'India', value: 'India', icon: require('../assets/icons/IN.png') },
  { text: 'Indonesia', value: 'Indonesia', icon: require('../assets/icons/ID.png') },
  { text: 'Ireland', value: 'Ireland', icon: require('../assets/icons/IE.png') },
  { text: 'Israel', value: 'Israel', icon: require('../assets/icons/IL.png') },
  { text: 'Italy', value: 'Italy', icon: require('../assets/icons/IT.png') },
  { text: 'Japan', value: 'Japan', icon: require('../assets/icons/JP.png') },
  { text: 'Lithuania', value: 'Lithuania', icon: require('../assets/icons/LT.png') },
  { text: 'Malaysia', value: 'Malaysia', icon: require('../assets/icons/MY.png') },
  { text: 'Mexico', value: 'Mexico', icon: require('../assets/icons/MX.png') },
  { text: 'Morocco', value: 'Morocco', icon: require('../assets/icons/MA.png') },
  { text: 'Netherlands', value: 'Netherlands', icon: require('../assets/icons/NL.png') },
  { text: 'New Zealand', value: 'New Zealand', icon: require('../assets/icons/NZ.png') },
  { text: 'Norway', value: 'Norway', icon: require('../assets/icons/NO.png') },
  { text: 'Philippines', value: 'Philippines', icon: require('../assets/icons/PH.png') },
  { text: 'Poland', value: 'Poland', icon: require('../assets/icons/PL.png') },
  { text: 'Portugal', value: 'Portugal', icon: require('../assets/icons/PT.png') },
  { text: 'Romania', value: 'Romania', icon: require('../assets/icons/RO.png') },
  { text: 'Russia', value: 'Russia', icon: require('../assets/icons/RU.png') },
  { text: 'Singapore', value: 'Singapore', icon: require('../assets/icons/SG.png') },
  { text: 'South Africa', value: 'South Africa', icon: require('../assets/icons/ZA.png') },
  { text: 'South Korea', value: 'South Korea', icon: require('../assets/icons/KR.png') },
  { text: 'Spain', value: 'Spain', icon: require('../assets/icons/ES.png') },
  { text: 'Sri Lanka', value: 'Sri Lanka', icon: require('../assets/icons/LK.png') },
  { text: 'Sweden', value: 'Sweden', icon: require('../assets/icons/SE.png') },
  { text: 'Switzerland', value: 'Switzerland', icon: require('../assets/icons/CH.png') },
  { text: 'Taiwan', value: 'Taiwan', icon: require('../assets/icons/TW.png') },
  { text: 'Turkey', value: 'Turkey', icon: require('../assets/icons/TR.png') },
  { text: 'Ukraine', value: 'Ukraine', icon: require('../assets/icons/UA.png') },
  {
    text: 'United Arab Emirates',
    value: 'United Arab Emirates',
    icon: require('../assets/icons/AE.png'),
  },
  { text: 'United Kingdom', value: 'United Kingdom', icon: require('../assets/icons/GB.png') },
  { text: 'Vietnam', value: 'Vietnam', icon: require('../assets/icons/VN.png') },
];

export const LANGUAGE_OPTIONS = [
  'Arabic',
  'Bengali',
  'English',
  'French Canadian',
  'French',
  'German',
  'Hebrew',
  'Hindustani',
  'Italian',
  'Japanese',
  'Korean',
  'Malay',
  'Mandarin',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Spanish',
  'Swedish',
  'Tamil',
  'Telugu',
];

export const NEW_MESSAGE_SUBSCRIPTION = 'newMessage';
export const MESSAGE_READ_SUBSCRIPTION = 'newMessageRead';

export const MEDITATION_RESOURCE_TYPE = 'Meditation';
export const PROGRAM_RESOURCE_TYPE = 'Program';
export const BENEFIT_RESOURCE_TYPE = 'Benefit';

export enum PresenceState {
  Online = 'ONLINE',
  LiveCoaching = 'LIVE_COACHING',
  Offline = 'OFFLINE',
}

export const DAY_NAMES: Record<string, string> = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
};

export enum ProviderType {
  COACH = 'Coach',
  THERAPIST = 'Therapist',
  PSYCHIATRIST = 'Psychiatrist',
}

export enum InsuranceStatus {
  ELIGIBLE = 'Eligible',
  NOT_ELIGIBLE = 'Not Eligible',
  INCOMPLETE = 'Incomplete',
}
